import { useNavigate } from 'react-router-dom';
import sty from './Privacy.module.css';

const Privacy = () => {
    return (
        <div className="bg">
            <div className="main-container" >
                <div className="page-tit">
                    <div className="page-tit-outer">
                        <p className="page-tit-txt">プライバシーポリシー</p>
                        <div className="page-tit-border"></div>
                    </div>
                </div>

                <div className="inner-container">
                    <div className={sty['privacy__in']}>
                        <div className={sty['privacy__in-txt']}>
                            株式会社ブローウィッシュ（以下「当社」といいます。）は、当社が提供するWebサービス「EngineerCloud」（以下「本サービス」）におけるユーザーの個人情報を、関連法令（個人情報保護法等）に従い、適切に取り扱います。
                        </div>
                    </div>

                    <div className={sty['privacy__con']}>
                        <div className={sty['privacy__tit']}>1.収集する情報</div>
                        <div className={sty['privacy__txt']}>
                            <p className={sty['privacy__cap']}>
                                当社は、以下の情報を収集する場合があります。
                            </p>
                            <p className={sty['privacy__cap']}>
                                (1)氏名、メールアドレス、所属先、役職、プロフィール画像等、ユーザーが登録時に入力する情報<br/>
                                (2)本サービス利用状況（アクセス日時、IPアドレス、ブラウザ情報、Cookie情報、端末情報等）<br/>
                                (3)本サービス上で登録されたスキル・経歴・プロフィール・投稿内容等<br/>
                                (4)お問い合わせ時に取得する氏名、メールアドレス、問い合わせ内容
                            </p>
                        </div>
                    </div>

                    <div className={sty['privacy__con']}>
                        <div className={sty['privacy__tit']}>2.利用目的</div>
                        <div className={sty['privacy__txt']}>
                            <p className={sty['privacy__cap']}>
                                当社は、収集した情報を以下の目的で利用します。
                            </p>
                            <p className={sty['privacy__cap']}>
                                (1) 本サービスの提供、運営、機能改善<br/>
                                (2) 本人確認、認証、不正利用防止、セキュリティ強化<br/>
                                (3) ユーザーへの通知、連絡、サポート対応<br/>
                                (4) 統計データの作成・分析、マーケティング利用(個人が特定されない形式)<br/>
                                (5) Google Analytics等を用いた利用状況の解析、広告効果測定<br/>
                                (6) ユーザーの同意に基づく外部サービスとの連携
                            </p>
                        </div>
                    </div>

                    <div className={sty['privacy__con']}>
                        <div className={sty['privacy__tit']}>3.第三者提供</div>
                        <div className={sty['privacy__txt']}>
                            <p className={sty['privacy__cap']}>
                                当社は、以下の場合を除き、ユーザーの同意なく個人情報を第三者に提供しません。
                            </p>
                            <p className={sty['privacy__cap']}>
                                (1)法令に基づく場合<br/>
                                (2)利用目的達成に必要な範囲で業務委託先に提供する場合<br/>
                                (3)人命・財産保護のために必要であり、本人同意を得ることが困難な場合
                            </p>
                        </div>
                    </div>

                    <div className={sty['privacy__con']}>
                        <div className={sty['privacy__tit']}>4.委託先・海外サーバー利用</div>
                        <div className={sty['privacy__txt']}>
                            <p className={sty['privacy__cap']}>
                                当社は、AWS（Amazon Web Services）等のクラウドサービスを利用し、海外のサーバーにデータが保存される場合があります。これらのサービス提供者は十分なセキュリティ体制を備えており、当社は安全管理措置を講じた上で利用します。
                            </p>
                        </div>
                    </div>

                    <div className={sty['privacy__con']}>
                        <div className={sty['privacy__tit']}>5.Cookie等の利用</div>
                        <div className={sty['privacy__txt']}>
                            <p className={sty['privacy__cap']}>
                                当社は、本サービスの利便性向上やアクセス解析のため、Cookieや類似技術を利用します。Google Analytics、広告配信サービスを利用する場合があります。ユーザーはブラウザの設定でCookieの利用を拒否できますが、一部機能が利用できない可能性があります。
                            </p>
                        </div>
                    </div>

                    <div className={sty['privacy__con']}>
                        <div className={sty['privacy__tit']}>6.データの保存期間</div>
                        <div className={sty['privacy__txt']}>
                            <p className={sty['privacy__cap']}>
                                当社は、個人情報を利用目的の達成に必要な期間、または法令で定められた期間保存します。退会後は、速やかに削除または匿名化します。ただし、法的義務やセキュリティ上の理由で一定期間保存する場合があります。
                            </p>
                        </div>
                    </div>

                    <div className={sty['privacy__con']}>
                        <div className={sty['privacy__tit']}>7.開示・訂正・削除</div>
                        <div className={sty['privacy__txt']}>
                            <p className={sty['privacy__cap']}>
                                ユーザーは、当社が保有する自身の個人情報について、開示・訂正・削除・利用停止を求めることができます。
                            </p>
                        </div>
                    </div>

                    <div className={sty['privacy__con']}>
                        <div className={sty['privacy__tit']}>8.改定</div>
                        <div className={sty['privacy__txt']}>
                            <p className={sty['privacy__cap']}>
                                当社は必要に応じて本ポリシーを改定することがあります。改定後は本サービス上に掲載された時点で効力を生じます。
                            </p>
                        </div>
                    </div>

                    <div className={sty['privacy__con']}>
                        <div className={sty['privacy__txt-last']}>
                            <p>2025年9月26日制定</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Privacy;


